import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "./i18n/i18n"

import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import keycloak from "./keycloak";
import {ReactKeycloakProvider} from '@react-keycloak/web/lib/provider';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(
    <BrowserRouter>
        <ReactKeycloakProvider
            authClient={keycloak}
            initOptions={{onLoad: 'login-required', checkLoginIframe: false, scope: "profile email taal"}}>
            <App/>
        </ReactKeycloakProvider>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
